import { pgTable, text, integer, timestamp, uuid, uniqueIndex, index } from "drizzle-orm/pg-core";

// ---------------------------------------------------------------------------
// Workflow Enrollment Checkpoints — read model for DO state snapshots
// ---------------------------------------------------------------------------

/**
 * Persisted snapshots of enrollment state from Durable Objects.
 * DO storage is the source of truth. This table is a read model
 * populated by the checkpoint queue consumer for queries, DSAR
 * compliance, and admin dashboards.
 *
 * Distinct from marketing.workflowEnrollments which tracks the
 * email marketing enrollment lifecycle.
 */
export const workflowEnrollmentCheckpoints = pgTable("workflow_enrollment_checkpoints", {
  id: uuid("id").primaryKey().defaultRandom(),
  enrollmentId: text("enrollment_id").notNull(),
  tenantId: text("tenant_id").notNull(),
  workflowId: text("workflow_id").notNull(),
  workflowVersion: integer("workflow_version").notNull(),
  contactId: text("contact_id").notNull(),
  currentNodeId: text("current_node_id"),
  state: text("state").notNull(),
  stepRetryCount: integer("step_retry_count").notNull().default(0),
  messagesSent: integer("messages_sent").notNull().default(0),
  correlationId: text("correlation_id").notNull(),
  triggerEventId: text("trigger_event_id").notNull(),
  errorMessage: text("error_message"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull(),
  lastTransitionAt: timestamp("last_transition_at", { withTimezone: true }).notNull(),
  completedAt: timestamp("completed_at", { withTimezone: true }),
  checkpointedAt: timestamp("checkpointed_at", { withTimezone: true }).notNull(),
  // WF-G: workflow-level wall-clock deadline. Nullable — fire-and-forget
  // marketing flows leave it null; SLA-bounded flows ("send reminder >=1h
  // before slot") set this so the action consumer can reject expired
  // dispatches before they cause side-effects. See WF-E packet §F2.
  deadlineAt: timestamp("deadline_at", { withTimezone: true }),
}, (table) => [
  uniqueIndex("uq_enrollment_checkpoint_tenant").on(table.tenantId, table.enrollmentId),
  index("idx_enrollment_checkpoint_state").on(table.tenantId, table.state),
  index("idx_enrollment_checkpoint_contact").on(table.tenantId, table.contactId),
]);
